import { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import Stars from "@/components/Stars";
import { listTestimonials } from "@/lib/adminApi";

const INTERVAL = 7000;

// A slow, one-at-a-time slider of collector words. Hidden when empty.
export default function Testimonials() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    listTestimonials().then(setItems).catch((e) => console.error("testimonials", e));
  }, []);

  const go = (next) => {
    if (items.length < 2) return;
    setIdx((next + items.length) % items.length);
  };

  useEffect(() => {
    if (paused || items.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), INTERVAL);
    return () => clearInterval(t);
  }, [paused, items.length]);

  if (!items.length) return null;

  return (
    <aside
      className="testi"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      data-testid="testimonials"
    >
      <p className="testi__overline mono-caps">Words from collectors</p>
      <div className="testi__stack">
        {items.map((it, i) => (
          <figure
            key={it.id}
            className={`testi__card${i === idx ? " is-in" : ""}`}
            aria-hidden={i !== idx}
            data-testid={i === idx ? "testimonial-active" : undefined}
          >
            <Stars rating={it.rating} size={15} className="testi__stars" testId={i === idx ? "testimonial-stars" : undefined} />
            <blockquote className={`testi__quote${it.quote.length > 280 ? " testi__quote--long" : ""}`} data-testid={i === idx ? "testimonial-quote" : undefined}>
              {it.quote}
            </blockquote>
            <figcaption className="testi__name mono-caps" data-testid={i === idx ? "testimonial-name" : undefined}>
              — {it.name}
            </figcaption>
          </figure>
        ))}
      </div>
      {items.length > 1 && (
        <div className="testi__controls">
          <button type="button" className="testi__arrow" onClick={() => go(idx - 1)} aria-label="Previous testimonial" data-testid="testimonial-prev">
            <ArrowLeft size={16} strokeWidth={1.4} />
          </button>
          <div className="testi__dots" role="tablist">
            {items.map((it, i) => (
              <button
                key={it.id}
                type="button"
                role="tab"
                aria-selected={i === idx}
                className={`testi__dot${i === idx ? " is-active" : ""}`}
                onClick={() => go(i)}
                aria-label={`Testimonial ${i + 1}`}
                data-testid={`testimonial-dot-${i}`}
              />
            ))}
          </div>
          <button type="button" className="testi__arrow" onClick={() => go(idx + 1)} aria-label="Next testimonial" data-testid="testimonial-next">
            <ArrowRight size={16} strokeWidth={1.4} />
          </button>
          <span className="testi__count mono-caps" data-testid="testimonial-count">
            {String(idx + 1).padStart(2, "0")} / {String(items.length).padStart(2, "0")}
          </span>
        </div>
      )}
    </aside>
  );
}
